<h2 i18n="@@titleChargers">Chargers</h2>

@if (chargersLoaded()) {
	@if (chargers().length > 0) {
		<div class="card-container">
			<mat-card class="mat-elevation-z5">
				<mat-card-content>
					<mat-list>
						@for (charger of chargers(); track charger.serialNumber) {
							<mat-list-item [routerLink]="['/charger', charger.serialNumber]">
								@let connection = charger.cloudConnectionState;
								@let state = charger.chargerStatus.indicators.chargingState;
								@let serial = charger.serialNumber;
								<span matListItemIcon>{{ connection !== 'Online' ? '🟠' :
									state === 'Charging' ? '🟢' :
									state === 'Error' ? '🔴' : '🔵' }}</span>
								<span matListItemTitle>{{ serial }}</span>
								<span matListItemLine>{{ connection === 'Online' ? (state | chargingStateTranslate) : ('Offline' | chargingStateTranslate) }}</span>
								<div matListItemMeta>
									<button
										mat-icon-button
										[matMenuTriggerFor]="menu"
										#menuTrigger="matMenuTrigger"
										(click)="$event.stopPropagation()"
									>
										<mat-icon>more_vert</mat-icon>
									</button>
									<mat-menu #menu="matMenu">
										<button mat-menu-item (click)="menuTrigger.closeMenu(); openDeleteChargerDialog($event, serial)">
											<mat-icon color="warn">delete</mat-icon>
										<span i18n="@@Delete">Delete</span>
										</button>
									</mat-menu>
								</div>
							</mat-list-item>
						}
					</mat-list>
				</mat-card-content>
			</mat-card>
		</div>
	} @else {
		<span i18n="@@NoChargersAvailable">No chargers available!</span><br/><br/>
	}

	<button matButton="elevated" color="primary"
		(click)="authService.isInstaller() && openAddChargerDialog()"
		[disabled]="!authService.isInstaller()"
		i18n-matTooltip
		matTooltip="Only installers can add chargers"
		[matTooltipDisabled]="authService.isInstaller()"
		[disabledInteractive]="true"
	>
		<mat-icon>add</mat-icon>
		<span i18n="@@AddCharger">Add Charger</span>
	</button>
} @else {
	<mat-spinner />
}
